<template>
  <div>
    <div class="container">
      <div id="breadcrumbs">
        <ul>
          <li><a href="https://www.volkswagen.com.ar/es.html">Home</a></li>
          <li><a href="https://www.volkswagen.com.ar/es/postventa.html">Postventa</a></li>
          <li><a href="https://www.volkswagen.com.ar/es/postventa/servicios.html">Servicios</a></li>
          <li><strong>Contratos de Mantenimiento</strong></li>
        </ul>
      </div>
      <h3 class="text-center">Los siguientes vehículos <strong class="d-block">cuentan con servicios bonificados de serie</strong></h3>
      <div id="excepciones">
        <div class="arrows">
          <button id="prevArrow"><img src="../assets/flecha.png" class="girada" /></button>
          <button id="nextArrow"><img src="../assets/flecha.png" /></button>
        </div>
        <slick ref="slickExcepciones" :options="{infinite: false, slidesToShow: 4, arrows: true, prevArrow: '#prevArrow', nextArrow: '#nextArrow', responsive: [{ breakpoint: 1023, settings: { slidesToShow: 3 }}, { breakpoint: 767, settings: { slidesToShow: 1 }}]}">
          <div class="excepcion" v-for="(excepcion, index) in excepciones" :key="index">
            <img :src="ruta+excepcion.imagen" />
            <span v-text="excepcion.nombre"></span>
            <span v-text="excepcion.aclaracion"></span>
          </div>
        </slick>
        <p style="text-align: right; margin-top: 10px; margin-bottom: 0;"><small>* Válido para vehículos patentados a partir del 01/01/2021</small></p>
        <p style="text-align: right;"><small>** Válido para vehículos patentados a partir del 01/07/2021</small></p>
      </div>
      <h3 class="text-center">Seleccioná tu vehículo para comenzar</h3>
      <p class="text-center">¡Encontrá el contrato de mantenimiento ideal para vos!</p>
      <div id="autos">
        <div class="arrows">
          <button id="prevArrow2"><img src="../assets/flecha.png" class="girada" /></button>
          <button id="nextArrow2"><img src="../assets/flecha.png" /></button>
        </div>
        <slick ref="slick" :options="{infinite: false, slidesToShow: 4, arrows: true, prevArrow: '#prevArrow2', nextArrow: '#nextArrow2', responsive: [{ breakpoint: 1023, settings: { slidesToShow: 3 }}, { breakpoint: 767, settings: { slidesToShow: 1 }}]}">
          <div class="auto" v-for="(auto, index) in listado" @click="modelo = auto; paquete = null; mostrar = false;" :key="index" :class="modelo == auto ? 'seleccionado' : ''">
            <img :src="ruta+auto.imagen" />
            <span v-text="auto.nombre"></span>
          </div>
        </slick>
      </div>
      <div id="paquetes" v-if="modelo && modelo.paquetes.length">
        <h4>Seleccioná los servicios</h4>
        <div class="paquete" :class="paq == paquete ? 'seleccionado' : ''" v-for="(paq, index) in modelo.paquetes" :key="index" v-text="paq.nombre" @click="paquete = paq; mostrar = false;"></div>
      </div>
    </div>
    <div class="container-fluid" id="servicios">
      <div class="container" v-if="paquete && paquete.services.length">
        <div>
          <h3>Detalle de los servicios a realizar durante el período seleccionado</h3>
          <div v-for="(service, index) in paquete.services" :key="index" class="d-flex service">
            <label v-text="service.nombre"></label>
            <div class="servicios" v-if="paquete && service.servicios.length">
              <div class="servicio" v-for="(servicio, index) in service.servicios" :key="index">
                <img src="../assets/tic.png" />
                <span v-text="servicio.servicio"></span>
              </div>
            </div>
          </div>
          <p><small class="azul">** Revisión de sistema eléctrico, exterior y neumáticos, bajos del vehículo y vano motor.</small></p>
        </div>
        <div id="costo" v-if="paquete && paquete.services.length">
          <div class="container">
            <h4>El costo por el producto seleccionado es de $<span v-text="paquete.pivot.precio.toLocaleString('it-IT')"></span>***</h4>
            <ul id="ahorro">
              <li><img src="../assets/tic.png" /> Se congela el precio de los servicios al día de hoy</li>
              <li><img src="../assets/tic.png" /> Podés pagar en 3 o 6 cuotas sin interés abonando con tarjetas de crédito VISA, Mastercard y CABAL</li>
              <li><img src="../assets/tic.png" /> Podés obtener un 10% off abonando en efectivo, débito o con tarjetas de crédito VISA, Mastercard y CABAL en un pago</li>
              <li><img src="../assets/tic.png" />  Podés realizar tu servicio en cualquier Concesionario de nuestra red</li>
            </ul>
            <button @click="scrollAbajo()">Pedilo ahora</button>
            <p style="margin-top: 15px; margin-left: -15px;"><small v-text="legal"></small></p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div id="pasos">
        <div id="formulario" v-if="mostrar">
          <h4>Dejanos tus datos para ponernos en contacto</h4>
          <form autocomplete="off" @submit.prevent="enviarForm()" id="contact_form">
            <div class="form-row">
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('nombre') }">
                <float-label>
                  <input type="text" name="nombre" id="nombre" class="form-control efecto" placeholder="Nombre*" v-model="nombre" v-validate="'required|alpha_spaces|max:255'" data-vv-as="Nombre" />
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('nombre')" class="animated headShake text-danger">
                  {{ errors.first('nombre') }}
                </div>
              </div>
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('apellido') }">
                <float-label>
                  <input type="text" name="apellido" id="apellido" class="form-control efecto" placeholder="Apellido*" v-model="apellido" v-validate="'required|alpha_spaces|max:255'" data-vv-as="Apellido" />
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('apellido')" class="animated headShake text-danger">
                  {{ errors.first('apellido') }}
                </div>
              </div>
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('email') }">
                <float-label>
                  <input type="email" name="email" id="email" class="form-control efecto" placeholder="E-mail*" v-model="email" v-validate="'required|email'" data-vv-as="E-mail" />
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('email')" class="animated headShake text-danger">
                  {{ errors.first('email') }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('dni') }">
                <float-label>
                  <input type="text" name="dni" id="dni" class="form-control efecto" placeholder="DNI*" v-model="dni" v-validate="'required|numeric|max:12'" data-vv-as="DNI" />
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('dni')" class="animated headShake text-danger">
                  {{ errors.first('dni') }}
                </div>
              </div>
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('patente') }">
                <float-label>
                  <input type="text" name="patente" id="patente" class="form-control efecto" placeholder="Patente*" v-model="patente" v-validate="{ required: true, regex: /([A-Za-z]{3}\d{3})$|([A-Za-z]{2}\d{3}[A-Za-z]{2})$/ }" data-vv-as="Patente" />
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('patente')" class="animated headShake text-danger">
                  <!-- {{ errors.first('patente') }} -->
                  La patente debe tener el formato ABC123 o AB123CD, en mayúscula y sin espacios.
                </div>
              </div>
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('vin') }">
                <float-label>
                  <input type="text" name="vin" id="vin" class="form-control efecto" placeholder="VIN*" v-model="vin" v-validate="{ required: true, alpha_num: true, min: 17, max: 17, regex: /([^iñoqIÑOQ])$/ }" data-vv-as="VIN" />
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('vin')" class="animated headShake text-danger">
                  <!-- {{ errors.first('vin') }} -->
                  Es un código alfanumérico de 17 dígitos (no puede incluir las letras I, O, Q y Ñ) y único para cada vehículo. Se encuentra en la cédula verde.
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('telefono') }">
                <float-label>
                  <input type="text" name="telefono" id="telefono" class="form-control efecto" placeholder="Teléfono*" v-model="telefono" v-validate="'required|numeric|min:11|max:30'" data-vv-as="Teléfono" />
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('telefono')" class="animated headShake text-danger">
                  {{ errors.first('telefono') }}<br/>
                  Ingrese el número código de área y, en el caso de teléfonos celulares, sin el 15.
                </div>
              </div>
              <div class="col-12 col-md-4">
                <float-label label="Provincia">
                  <select name="provincia" class="form-control efecto no-appearance" placeholder="Provincia" v-model="provincia">
                    <option selected value>Provincia</option>
                    <option v-for="provincia in provincias" :key="provincia" :value="provincia">{{provincia}}</option>
                  </select>
                  <span class="focus-border"></span>
                </float-label>
              </div>
              <div class="col-12 col-md-4" :class="{ 'has-error': errors.has('concesionario') }">
                <float-label label="Concesionario">
                  <select name="concesionaria_id" class="form-control efecto no-appearance" placeholder="Concesionario" v-model="concesionario" v-validate="'required'" data-vv-as="Concesionario">
                    <option selected value>Concesionario</option>
                    <option v-if="Object.keys(select_concesionarias).length" v-for="concesionaria in select_concesionarias" :key="concesionaria.codigo" :value="concesionaria.codigo">{{ concesionaria.nombre }}</option>
                    <option v-else>Elegir provincia primero</option>
                  </select>
                  <span class="focus-border"></span>
                </float-label>
                <div v-if="errors.has('concesionario')" class="animated headShake text-danger">
                  {{ errors.first('concesionario') }}
                </div>
              </div>
              <div class="col-12">
                <div id="acepto" class="d-flex align-items-start justify-content-between"><input type="checkbox" name="consentimiento" v-model="consentimiento"><p><small>El titular de los datos personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326. La DIRECCION NACIONAL DE PROTECCION DE DATOS PERSONALES, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.</small></p></div>
              </div>
            </div>
          </form>
          <div>
            <div class="siguiente">
              <div class="d-flex align-items-center flex-column flex-sm-row">
                <button class="btn azul" type="button" @click="enviarForm()" :disabled="!consentimiento || !concesionario || !nombre || !apellido || !email || !telefono || !patente || !vin || cargando">Finalizar</button>
                <p class="asterisco" v-if="0">Tu formulario fue enviado. ¡Gracias!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cargando" style="position: absolute; background: rgba(255, 255, 255, 0.7); width: 100%; height: 100%; top: 0; left: 0;z-index: 12; display: flex; justify-content: center; align-items: center;">
        <img id="loading" src="../assets/loading.gif"/>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import FloatLabel from "vue-float-label/components/FloatLabel";
import axios from "axios";
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";

/* eslint-disable */
export default {
  name: "Precios",
  props: ["listado", "excepciones", "concesionarias", "query", "entorno", "legal"],
  components: {
    vSelect, FloatLabel, Slick
  },
  data() {
    return {
      cargando: false,
      ruta: "https://eficiencia-energetica.vwcontenidos.com.ar",
      // ruta: "http://eficiencia.test",
      consulta: 0,
      modelo: "",
      paquete: "",
      imagenModelo: "",
      patente: "",
      vin: "",
      seleccionado: [],
      consentimiento: false,
      email: '',
      nombre: '',
      apellido: '',
      dni: '',
      telefono: '',
      provincia: '',
      concesionario: '',
      select_concesionarias: [],
      mobile: false,
      mostrar: false,
      enviado: false,
      nombre_concesionaria: '', 
      email_concesionaria: ''
    };
  },
  mounted: function() {
    this.mobile = window.innerWidth < 767;
  },
  computed: {
    provincias: function() {
      return Object.keys(this.concesionarias).sort((a, b) =>
        a.localeCompare(b)
      );
    },
  },
  watch: {
    provincia: function(val) {
      if (val !== "") {
        this.select_concesionarias = this.concesionarias[val];
      }
    },
    concesionario: function(val) {
      if (val !== "") { 
        var self = this
        this.nombre_concesionaria = this.select_concesionarias.filter(function(el) {
          return el['codigo'] == self.concesionario;
        })[0].nombre;
        this.email_concesionaria = this.select_concesionarias.filter(function(el) {
          return el['codigo'] == self.concesionario;
        })[0].email_concesionaria;
      }
    }
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    scrollIntoView: function(selector, offset = 0) {
      setTimeout(function(){
        window.scrollTo({ top: document.getElementById(selector).offsetTop - offset, behavior: 'smooth'});
        // window.scroll(0, );
      }, 300);
    },
    editarCP() {
      var original = this.cp
      var nuevo = original.replace(/\D/g,'')
      this.cp = nuevo.slice(0, 4)
    },
    enviarGtag() {
      console.log('enviando gtag')
      window.gtag('event', 'conversion', {
        'send_to': 'AW-880716059/-oDdCO6tsnAQm9L6owM'
      });
      window.fbq('track', 'Mantenimiento');
    },
    enviarForm() {
      this.cargando = true;
      var self = this
      axios.post(this.ruta + "/api/reservar", { concesionario: this.concesionario, nombre_concesionaria: this.nombre_concesionaria, nombre: this.nombre, apellido: this.apellido, dni: this.dni, email: this.email, telefono: this.telefono, patente: this.patente.toUpperCase(), vin: this.vin, email_concesionaria: this.email_concesionaria, modelo: this.modelo.nombre, paquete: this.paquete.nombre, provincia: this.provincia }).then(response => {
        this.cargando = false;
        if(response.status == '200') {
          self.enviado = true
          self.limpiarForm()
          self.enviarGtag()
          this.$swal({
            title: '¡Gracias por comunicarte!',
            text: 'Muy pronto uno de nuestros representantes se comunicará con vos.',
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#001e50',
            confirmButtonText: 'OK'
          })
        } else {
          this.$swal({
            title: 'Parece que hubo un error',
            text: 'Por favor, volvé a intentar o comunicate con nosotros.',
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#001e50',
            confirmButtonText: 'OK'
          });
        }
      });
    },
    limpiarForm() {
      setTimeout(function(){
        document.getElementById("contact_form").reset()
      }, 500);
    },
    scrollAbajo() {
      this.mostrar = true;
      setTimeout(function(){
        var formulario = document.getElementById('pasos');
        formulario.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('nombre').focus();
      }, 400);
    }
  }
};
</script>

<style lang="scss">
  header>div>div>div>div>button {
    display: flex!important;
  }
  .rotado {
    transform: rotate(180deg);
  }
  .encabezado {
    position: relative;
    cursor: pointer;
    img {
      position: absolute;
      top: 3.5em;
      right: -1.7em;
      @media(max-width: 1441px) {
        top: 2em;
        width: 100px;
      }
      @media(max-width: 767px) {
        top: 0;
        right: -7px;
        width: 70px;
      }
    }
  }
  .form-group, .form-row {
    position: relative;
    color: #001e50;
    text-align: left;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    margin-bottom: 2em;
    &.no-margin {
      margin-bottom: 1.7em;
    }
    label {
      margin-bottom: 0;
      font-weight: 400;
      color: #001e50;
      text-align: left;
      letter-spacing: 0.03em;
      top: -0.9em;
      z-index: 0;
      font-size: 0.7em;
      @media(max-width: 767px) {
        font-size: 1.1em;
      }
    }
    span, div {
      &:focus {
        outline: none;
      }
    }
    input:not([type="radio"]),
    select,
    textarea {
      background-color: white;
      color: #001e50;
      border: none;
      border-bottom: 1px solid #DFE4E8;
      box-shadow: none;
      border-radius: 0;
      font-size: 1.2em;
      padding: 0;
      letter-spacing: -0.035em;
      height: auto;
      min-height: 1.7em;
      @media(max-width: 767px) {
        font-size: 1.7em;
        min-height: 2.5em;
        margin-bottom: 1em;
      }
      &:hover,
      &:focus {
        box-shadow: none;
        outline: none;
      }
      &:not([type="search"]):focus {
        outline: none;
        border-color: #DFE4E8;
      }
      &.efecto ~ .focus-border {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 1px;
        background-color: #001e50;
        transition: 0.4s;
      }
      &.efecto:focus ~ .focus-border {
        width: 100%;
        transition: 0.4s;
        left: 0;
      }
    }
    input[type="search"] {
      border: none!important;
      min-height: 1.4em!important;
    }
  }
  .form-row {
    margin-bottom: 3.6em;
    margin-top: -1em;
    &:last-child {
      margin-bottom: 0;
    }
    @media(max-width: 767px) {
      margin-top: 0;
      margin-bottom: 0;
    }
    .col-md-4 {
      input {
        width: 95%;
      }
    }
    .col-md-6 {
      select {
        width: 97%;
      }
    }
  }
  .dropdown {
    .dropdown-toggle {
      border: none!important;
    }
    .vs__selected-options {
      border-bottom: 1px solid #DFE4E8;
      padding: 0;
      align-items: center;
    }
    .selected-tag {
      color: #001e50;
      padding: 0;
      margin: 0;
      font-size: 1.25em;
      letter-spacing: -0.03em;
      @media(max-width: 767px) {
        font-size: 2em;
      }
    }
  }
  .form-control {
    border-radius: 0;
  }
  @media (orientation: portrait) {
    .buttons > .row {
      display: flex;
      flex-direction: column;
    }
  }
  #spacing1 {
    display: block;
    padding-top: 8.2em;
    @media(max-width: 767px) {
      padding-top: 4em;
    }
  }
  #spacing2 {
    display: block;
    padding-top: 4em;
    @media(max-width: 767px) {
      padding-top: 0;
    }
  }
  .margin-1 {
    margin-top: 2.5em;
  }
  .asterisco {
    color: #757575;
    font-size: 0.7em;
    margin: 0;
    margin-left: 8%;
    flex: 1;
    letter-spacing: 0.015em;
    margin-bottom: 4px;
    @media(max-width: 767px) {
      margin-left: 0;
      margin-top: 2em;
      font-size: 1.1em;
    }
  }
  .siguiente {
    margin-top: 1em;
    .d-flex {
      @media(max-width: 767px) {
        align-items: flex-start!important;
        button {
          margin-left: 0;
          margin-top: 2em;
        }
      }
    }
  }
  #acepto {
    margin-top: 3.2em;
    font-size: 0.9em;
    line-height: 1.1em;
    margin-left: 7px;
    color: #001e50;
    @media(max-width: 767px) {
      margin-left: 0;
      font-size: 1.5em;
      margin-top: 2em;
      padding-right: 2%;
    }
    input {
      margin-right: 17px;
    }
  }
  #loading {
    position: absolute;
    width: 150px;
    height: 150px;
    left: calc(50% - 75px);
    bottom: 15%;
    @media(max-width: 769px) {
      bottom: 40vh;
    }
  }
  .paquete, .auto {
    cursor: pointer;
  }
  .excepcion, .auto {
    text-align: center;
    span {
      display: block;
      letter-spacing: -0.01em;
      font-size: 0.95em;
      font-weight: bold;
      border-bottom: 2px solid white;
      margin-top: 1em;
      padding-bottom: 0.3em;
      @media(max-width: 767px) {
        font-size: 1.7em;
      }
      &+span {
        margin-top: -0.7em;
        font-weight: 400;
      }
    }
    &.seleccionado {
      span {
        border-bottom: 2px solid #001e50;
      }
    }
    img {
      width: 180px;
      height: 90px;
      object-fit: contain;
      margin: auto;
    }
  }
  .auto {
    padding: 0 10% 0.3em;
  }
  #formulario {
    form {
      margin-top: 2em;
    }
  }
  #excepciones, #autos {
    position: relative;
    margin-top: 3.2em;
    margin-bottom: 3.9em;
    @media(max-width: 767px) {
      margin-top: 6.2em;
      margin-bottom: 7.6em;
    }
  }
  #app #excepciones + h3 {
    @media(max-width: 767px) {
      margin-bottom: 0.4em;
    }
  }
  #autos {
    margin-bottom: 2em;
  }
  .girada {
    transform: rotate(180deg);
  }
  .arrows {
    position: absolute;
    width: 101%;
    // z-index: 2;
    top: 30%;
    height: 1px;
    margin-left: -0.5%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
    @media(max-width: 1441px) {
      width: 110%;
      margin-left: -4.5%;
    }
    .slick-arrow {
      border: none;
      background: none;
    }
  }
  ul {
    padding: 0;
    margin: 0;
  }
  #breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    padding: 0.75em 0;
    font-size: 1.1em;
    @media(max-width: 767px) {
      display: none;
    }
    ul {
      width: 100%;
      display: flex;
    }
    li {
      display: flex;
      -webkit-box-align: baseline;
      align-items: baseline;
      margin-right: 10px;
      margin-bottom: 10px;
      line-height: 1.4em;
      &:not(:first-child):before {
        content: "";
        margin-right: 9px;
        width: 0px;
        height: 0px;
        border-left: 0.4em solid rgb(0, 30, 80);
        border-top: 0.25em solid transparent;
        border-bottom: 0.25em solid transparent;
      }
      a {
        // text-decoration: underline;
        color: #001e50;
        border-bottom: 1px solid #001e50;
      }
      strong {
        letter-spacing: -0.01em;
      }
    }
  }
  #paquetes {
    padding: 0 10% 1.7em;
    @media(max-width: 767px) {
      padding: 3em 5%;
    }
  }
  .paquete, .servicio, button {
    display: inline-block;
    border: 2px solid #001e50;
    margin: 0.9em 1.1em 0 0;
    padding: 0.35em 2.1em 0.4em;
    border-radius: 1.4em;
    font-size: 1.1em;
    color: #001e50;
    &:hover, &.seleccionado {
      background: #001e50;
      color: white;
    }
    @media(max-width: 767px) {
      font-size: 1.8em;
    }
  }
  #app #servicios {
    background: #DFE4E8;
    margin-top: 2.9em;
    .container {
      padding-top: 3.4em;
      padding-bottom: 3.4em;
    }
    h3 {
      margin-bottom: 0.3em;
      @media(max-width: 767px) {
        margin-top: 6px;
      }
    }
    .service {
      border-bottom: 1px solid white;
      padding: 2.9em 0 1.4em;
      margin-bottom: 0.8em;
      &:last-child {
        padding-bottom: 2em;
      }
      @media(max-width: 767px) {
        padding-top: 0;
        flex-direction: column;
      }
      label {
        min-width: 6em;
        color: #001e50;
        font-size: 1.7em;
        font-weight: 300;
        @media(max-width: 767px) {
          font-size: 2.75em;
          font-weight: 400;
          padding: 2px 2px 7px;
        }
      }
      .servicio {
        background: white;
        color: #001e50!important; 
        margin-top: 0;
        margin-bottom: 1em;
        img {
          margin-left: -10px;
          margin-right: 10px;
          margin-top: -2px;
          @media(max-width: 767px) {
            margin-left: -17px;
          }
        }
      }
    }
    #costo {
      h4 {
        margin-left: -15px;
        font-size: 2em;
        color: #001e50;
        @media(max-width: 767px) {
          font-size: 3em;
          margin-top: 0.7em;
          letter-spacing: 0;
          line-height: 1.4em;
        }
      }
      button {
        margin-left: -15px;
        background: #001e50;
        color: white;
        margin-top: 3em;
        @media(max-width: 767px) {
          margin-top: 2.4em;
          margin-bottom: 1em;
        }
        &:hover {
          color: #001e50;
          background: white;
        }
      }
    }
  }
  #pasos {
    @media(max-width: 767px) {
      padding: 0 17px;
    }
  }
  #formulario {
    padding: 6em 0;
    @media(max-width: 767px) {
      padding: 5em 0;
    }
    h4 {
      font-size: 2em;
      margin-bottom: 2.4em;
      @media(max-width: 767px) {
        font-size: 3em;
        line-height: 1.4em;
        margin-bottom: 1.5em;
      }
    }
  }
  .slick-arrow img {
    width: 34px;
  }
  #ahorro {
    margin-left: -15px;
    font-size: 1.2em;
    font-weight: 300;
    @media(max-width: 767px) {
      line-height: 1.2em;
      font-size: 2em;
      li {
        margin-bottom: 0.7em;
      }
    }
    img {
      margin-right: 7px;
    }
  }
  .azul {
    color: #001e50;
  }
  .slick-disabled {
    opacity: 0.2;
  }
  // { required: false, regex:/^(\d{4})-(\d{2})-(\d{2})$/ }
</style>